import BaseService from '@src/services/BaseService'

class TeamsService extends BaseService {
    constructor() {
        super('teams')
    }
}

export default new TeamsService()
